class ProductGallery extends HTMLElement { // eslint-disable-line
  constructor() {
    super()
    this.swipers = this.querySelectorAll('.swiper')
    this.colorKey = `option${this.dataset.colorIndex}`
  }

  connectedCallback() {
    if (!this.swipers.length) { return }
    const firstVisisbleSwiperEl = [...this.swipers].find(swiperEl => !swiperEl.classList.contains('hidden'))
    const swiperOptions = {
      slidesPerView: 1,
      threshold: 10,
      draggable: true,
      mousewheel: true,
      slidesPerGroup: 1,
      loop: true,
      mousewheel: {
        forceToAxis: true
      },
      pagination: {
        el: firstVisisbleSwiperEl.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: firstVisisbleSwiperEl.querySelector('.swiper-button-next'),
        prevEl: firstVisisbleSwiperEl.querySelector('.swiper-button-prev')
      }
    }
    const newSwiper = new Swiper(firstVisisbleSwiperEl, swiperOptions)
    newSwiper.on('beforeSlideChangeStart', () => window.pauseAllMedia())
  }

  updateProductGallery(variant) {
    if (!this.swipers.length) { return }

    const variantColor = variant[this.colorKey]

    this.swipers.forEach(swiper => {
      const color = swiper.dataset.color
      swiper.classList.toggle('hidden', variantColor !== color)
    })

    const activeSwiper = [...this.swipers].find(swiper => !swiper.classList.contains('hidden'))

    if (!activeSwiper.classList.contains('swiper-initialized')) {
      const swiperOptions = {
        slidesPerView: 1,
        threshold: 10,
        draggable: true,
        mousewheel: true,
        slidesPerGroup: 1,
        loop: true,
        mousewheel: {
          forceToAxis: true
        },
        pagination: {
          el: activeSwiper.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: activeSwiper.querySelector('.swiper-button-next'),
          prevEl: activeSwiper.querySelector('.swiper-button-prev')
        }
      }

      const newSwiper = new Swiper(activeSwiper, swiperOptions)
      document.addEventListener('updateProductGallery', () => newSwiper.slideTo(0, 0))
      newSwiper.on('beforeSlideChangeStart', () => window.pauseAllMedia())
    }
  }
}

customElements.define('product-gallery', ProductGallery);

